// Team seat-limit constants per tier. The UI uses these to display limits and
// trigger upgrade / extra-seat prompts. Actual team membership data lives in
// Supabase `organization_members` and `team_invitations` — see
// `frontend/src/data/teamMembers.ts` for the hooks.

import type { OrgTier } from '@/contexts/AuthContext'

export const TEAM_MEMBER_LIMITS: Record<OrgTier, number> = {
  free: 1, // Owner only
  pro: 3, // Owner + 2
  business: 10, // 10 included; extra seats billed
}

// $5/month per additional seat beyond the Business tier's included 10.
export const EXTRA_TEAM_MEMBER_COST = 5

export function getTeamMemberLimit(tier: OrgTier): number {
  return TEAM_MEMBER_LIMITS[tier]
}

export function wouldExceedTeamLimit(tier: OrgTier, currentCount: number): boolean {
  return currentCount >= TEAM_MEMBER_LIMITS[tier]
}
